/**
 * Mirrors EDailyJobStatus in the API
 * (libs/common/src/lib/enums/daily-job.enum.ts on origin/staging).
 */
export enum DailyJobStatus {
  ALL = -1,
  CANCEL = 0,
  DRAFT = 1,
  OPEN = 2,
  APPROVE = 3,
  REJECT = 4,
}

export const DailyJobStatusLabel: Record<DailyJobStatus, string> = {
  [DailyJobStatus.ALL]: 'Semua',
  [DailyJobStatus.CANCEL]: 'Dibatalkan',
  [DailyJobStatus.DRAFT]: 'Draft',
  [DailyJobStatus.OPEN]: 'Open',
  [DailyJobStatus.APPROVE]: 'Selesai',
  [DailyJobStatus.REJECT]: 'Ditolak',
};

/** Tailwind text/bg pairs, following the palette the React mock used. */
export const DailyJobStatusClass: Record<DailyJobStatus, string> = {
  [DailyJobStatus.ALL]: 'text-[#7C7C7C] bg-[#F1F1F1]',
  [DailyJobStatus.CANCEL]: 'text-[#7C7C7C] bg-[#F1F1F1]',
  [DailyJobStatus.DRAFT]: 'text-[#7C7C7C] bg-[#F1F1F1]',
  [DailyJobStatus.OPEN]: 'text-[#0068FF] bg-[#CDE9FF]',
  [DailyJobStatus.APPROVE]: 'text-[#45C21F] bg-[#EBFDD4]',
  [DailyJobStatus.REJECT]: 'text-[#FF5468] bg-[#FFF1EC]',
};

/**
 * The `status` query param on GET /daily-jobs is a bucket selector, NOT a
 * DailyJobStatus, despite being typed as one. The service branches on it:
 *   1          -> DRAFT + OPEN + REJECT
 *   any other  -> APPROVE + CANCEL
 *
 * Note REJECT sits in the ongoing bucket: a rejected job is still the user's
 * to act on. The list is also windowed to the last 7 days server-side.
 */
export enum DailyJobListFilter {
  ONGOING = 1,
  DONE = 2,
}

/** Only a draft can be edited or submitted from the app. */
export const isEditableStatus = (status: DailyJobStatus): boolean =>
  status === DailyJobStatus.DRAFT || status === DailyJobStatus.REJECT;

export const isSubmittableStatus = (status: DailyJobStatus): boolean =>
  status === DailyJobStatus.DRAFT || status === DailyJobStatus.REJECT;
